import { MarkerClusterer } from '@googlemaps/markerclusterer';
import { Subject } from "rxjs";
import GtmService from '../gtm/gtm.service';

class MapCtrl {
	weekActiveList = {};
	touchStarted = false;
	lastTouchId = null;

	ordinatiS = {
		"street_number": true,
		"route": true,
		"locality": true,
		"administrative_area_level_1": true,
		"administrative_area_level_2": true,
		"administrative_area_level_3": true,
		"country": true,
		"postal_code": true,
	};

	listCountryCode = [];


	constructor($scope, $location, $timeout, $document, $window, $http, StateService, $compile) {
		this.$scope = $scope;
		this.$location = $location;
		this.$timeout = $timeout;
		this.$document = $document;
		this.$window = $window;
		this.$http = $http;
		this.$compile = $compile;
		this.data = window.data || {};
		this.model = {};
		this.isLoadingMap = true; // Variabile per tracciare lo stato di caricamento della mappa

		if (this.$location.search() && this.$location.search().email) {
			this.model.email = this.$location.search().email;
		}
		this.state = StateService.getState();
		this.state.ready();
		this.formSubmitted = false;
		this.unsubscribe = new Subject();

		this.stores = [];
		this.filteredStores = [];
		this.showResults = false;
		this.showMap = true; // Stato di default attivo
		this.sortCriteria = 'rilevanza'; // default sorting criteria
		this.activeStore = null; // currently active store
		this.searchLocation = null; // store the location of the search
		this.searchQuery = ''; // Bind search query
		this.fancyStore = null; // store for fancybox
		this.fancyAgent = null; // agent for fancybox
		this.showBtnTop = false; // Flag to show/hide .btn-top
		this.centerMapOnStore = this.centerMapOnStore.bind(this);
		this.infoWindow = null;

		this.searchLocationLat = null;
		this.searchLocationLng = null;



		// Utilizzare storeLocatorSettings dal contesto globale
		this.storeLocatorSettings = window.storeLocatorSettings || {};


		this.headquarter = {
			name: "LEA CERAMICHE",
			address: "Via Cameazzo 21, Fiorano Modenese",
			lat: 44.5325,
			lng: 10.8326,
			type: "Sede Centrale",
			country: "IT",
			phone: "0536 837811",
			hours: null,
		};

		this.loadStores();
		this.loadGoogleMaps();
		//this.addSearchButtonClickListener();
		this.addProvinceClickListener();
		this.setupTabletTouchHandlers(); // Aggiungi event listeners nativi

		// Ascolta i cambiamenti di $location
		$scope.$on('$locationChangeSuccess', () => {
			this.checkAndPerformSearch();
		});

		$scope.$on('destroy', () => {
			this.unsubscribe.next();
			this.unsubscribe.complete();
		});

		// $scope.$watch(() => this.sortCriteria, () => {
		//   this.sortStores();
		// });

		angular.element($document).on('scroll', this.handleScroll.bind(this));

	}

	// Aggiungi il listener per il click sul bottone di ricerca
	addSearchButtonClickListener() {

		const searchButton = document.getElementById('btn-search');
		if (searchButton) {
			searchButton.addEventListener('click', () => {
				window.data.searchByTextBox = true;
				this.handleSearchButtonClick();
			});
		}
	}
	// Funzione per gestire il click del bottone di ricerca
	handleSearchButtonClick() {
		const searchQuery = document.getElementById('searchBox').value;
		if (searchQuery) {
			const geocoder = new google.maps.Geocoder();
			geocoder.geocode({ address: this.addressForGeocoder(searchQuery) }, (results, status) => {
				if (status === google.maps.GeocoderStatus.OK && results[0]) {
					const location = results[0].geometry.location;
					const formattedAddress = results[0].formatted_address;

					var country = results[0].address_components.find(component => component.types.includes("country"))?.short_name || '';
					country = country.toUpperCase();
					if (!this.listCountryCode.find(c => c.toUpperCase() == country)) {
						document.getElementById('searchBox').value = "";
						return;
					}

					document.getElementById('searchBox').value = formattedAddress; // Completa il campo di ricerca con il nome completo della città

					this.performSearchWithLocation(location, formattedAddress); // Avvia la ricerca
				} else {
					console.error('Geocoder failed due to: ' + status);
				}
			});
		} else {
			console.warn('Il campo di ricerca è vuoto.');
		}
	}

	handleScroll() {
		const wrapMap = this.$document[0].querySelector('.wrap-map');
		const listStore = this.$document[0].querySelector('.listStore');

		if (wrapMap && listStore) {
			const wrapMapRect = wrapMap.getBoundingClientRect();
			const listStoreRect = listStore.getBoundingClientRect();

			if (wrapMapRect.bottom < 0 && listStoreRect.top < window.innerHeight) {
				this.$timeout(() => {
					this.showBtnTop = true;
				});
			} else {
				this.$timeout(() => {
					this.showBtnTop = false;
				});
			}
		}
	}

	addProvinceClickListener() {
		// Assicurati che il DOM sia completamente caricato
		this.$timeout(() => {
			const provinceLinks = document.querySelectorAll('.wrap-provincie .item ul li a');
			provinceLinks.forEach(link => {
				link.addEventListener('click', (event) => {
					window.data.searchByTextBox = false;

					const titleElement = link.querySelector('span');

					if (titleElement) {
						// Usa il testo del titolo come nome provincia
						const selectedProvince = titleElement.textContent;
						localStorage.setItem('selectedProvince', selectedProvince);

						var provGA4 = link.getAttribute("data-title");
						// Emissione unica dell'evento "store_locator_province"
						this.emitProvinceEventOnce(provGA4);
					}
				});
			});
		}, 0);
	}

	addressForGeocoder(address) {
		let addressToSearch = address;

		// La mappa per Cotto d'este è impostata sempre su lingua EN.
		// Questo impedisce di trovare risultati quando si cerca solo il CAP.
		//
		// Questa modifica quando sto in Italiano e cerco una sola parola
		// aggiunge "Italy" alla ricerca.
		// (Aiuta per la ricerca del cap, ma dovebbre essere utile anche per i nomi di città)
		if (!(addressToSearch + "").match(" ")) {
			const locale = this.getCurrentLocale();
			const { country } = this.getCountryAndCenter(locale);
			if (country === "IT")
				addressToSearch += ", Italy";
		}

		return addressToSearch;
	}


	getCountryAndCenter(locale) {
		const mapSettings = {
			it_IT: { country: 'IT', center: { lat: 41.9028, lng: 12.4964 } },
			fr_FR: { country: 'FR', center: { lat: 48.8566, lng: 2.3522 } },
			de_DE: { country: 'DE', center: { lat: 52.5200, lng: 13.4050 } },
			de_AT: { country: 'AT', center: { lat: 48.2082, lng: 16.3738 } },
			nl_BE: { country: 'BE', center: { lat: 50.8503, lng: 4.3517 } },
			de_CH: { country: 'CH', center: { lat: 46.2044, lng: 6.1432 } },
			fr_CH: { country: 'CH', center: { lat: 46.2044, lng: 6.1432 } }
		};
		return mapSettings[locale] || { country: 'US', center: { lat: 37.7749, lng: -122.4194 } };
	}

	emitProvinceEventOnce(provincia) {
		if (!this.provinceEventEmitted) { // Verifica che l'evento non sia già stato emesso
			const obj = Object.assign({}, window.objDataLayerInfo);
			obj["eventname"] = "store_locator_province";
			obj["label"] = provincia;
			GtmService.push(obj);

			// Disabilita l'emissione dell'evento per i click successivi
			this.provinceEventEmitted = true;
		}
	}

	checkAndPerformSearch() {
		const path = this.$location.path();
		const selectedProvince = window.data.provincia;

		if (path === '/punti-vendita') {
			// Siamo sulla pagina principale, quindi puliamo il campo di ricerca
			this.searchQuery = '';
			localStorage.removeItem('selectedProvince');
			
			const searchBox = document.getElementById('searchBox');
			if (searchBox) {
				searchBox.value = '';
			}

			const searchBoxBottom = document.getElementById('searchBoxBottom');
			if (searchBoxBottom) {
				searchBoxBottom.value = '';
			}

			this.$timeout(() => {
				this.filteredStores = [];
				this.showResults = false;
			});
		} else if (selectedProvince) {
			this.searchQuery = selectedProvince;

			// Aspetta che la mappa sia caricata prima di eseguire la ricerca
			this.$timeout(() => {
				if (this.map) {
					this.performSearch();
				} else {
					this.$timeout(this.checkAndPerformSearch.bind(this), 100); // Riprova finché la mappa non è pronta
				}
			}, 0);
		}
	}

	getListCountryRestriction() {
		const countryRestriction = this.getCountryRestriction();

		const autocompleteOptions = { types: ['geocode'] };

		if (countryRestriction.country === "it") // Per l'Italia faccio una ricerca più estesa, per prendere anche San Marino e Vaticano
		{
			autocompleteOptions.componentRestrictions = { country: [countryRestriction.country, "sm", "va"] };
		}
		else
			if (countryRestriction.country === "fr") {
				autocompleteOptions.componentRestrictions = { country: [countryRestriction.country, 'gp', 're', 'mq', 'gf', 'nc', 'yt', 'pf'] };
			}
			else {
				autocompleteOptions.componentRestrictions = { country: [countryRestriction.country] };
			}
		this.listCountryCode = autocompleteOptions.componentRestrictions.country;

		return autocompleteOptions;
	}

	getCurrentLocale() {
		const metaLocale = document.querySelector('meta[property="og:locale"]').getAttribute('content');
		return metaLocale;
	}

	getCountryRestriction() {
		const locale = this.getCurrentLocale();
		if (locale === 'fr_FR') {
			return { country: 'fr', center: { lat: 48.8566, lng: 2.3522 } }; // Center of France
		} else {
			return { country: 'it', center: { lat: 41.8719, lng: 12.5674 } }; // Center of Italy
		}
	}

	setProvinces() {
		this.$timeout(() => {
			this.provinces = this.data.provinces.filter(x => x.countryId === this.model.Nazione);
		});
	}

	filterProvinces() {
		this.$timeout(() => {
			this.data.filteredProvinces = this.data.provinces.filter(province => province.countryId === this.model.Nazione);
		});
	}

	openInfoWindow(marker, store) {
		const storeStatus = this.isStoreOpen(store);
		const hoursHtml = this.generateHoursHtml(store);
		const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${marker.getPosition().lat()},${marker.getPosition().lng()}`;
		const currentDay = this.getCurrentDay();

		let nomeSt = store.name;
		if (!nomeSt) { nomeSt = "-" }
		else {
			nomeSt = nomeSt.replaceAll(" ", "_").toLowerCase() + "_";
			nomeSt = nomeSt.replaceAll("_-_", "_");
		}
		if (window.data.provinciaGA4 && !window.data.searchByTextBox) {
			nomeSt = nomeSt + window.data.provinciaGA4;
		} else {
			nomeSt += "-";
		}

		store.nomeContenuto = nomeSt;

		const wrapClass = store.type === 'Fidelity' ? 'wrap no-wrap' : 'wrap';

		const content = `
		<div class="infoWindowContent">
			<div class="infoHeader">
				<div class="${wrapClass}">
					<div class="storeType" ng-if="store.type !== 'Fidelity'">
						<div class="storeIcon">
							<svg ng-if="store.type === 'Lea Ceramiche Ambassador'" width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M6 0.5L11.1962 3.5V9.5L6 12.5L0.803848 9.5V3.5L6 0.5Z" fill="#404040" />
							</svg>
							<svg ng-if="store.type === 'Partner Lea Ceramiche'" width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M6 0.5L12 6.5L6 12.5L0 6.5L6 0.5Z" fill="#D6D2CE" />
							</svg>
						</div>
						{{ store.type }}
					</div>
					<div class="storeDistance">${store.distance} km</div>
					<div class="storeName">${store.name}</div>
				</div>
			</div>
			<div class="infoBody">
				<div class="storeAddress">${store.address}, ${store.city}</div>
				${hoursHtml ? `				<div class="storeHours">
					<div class="hoursTitle">Orari</div>
					<div class="today">
						<div role="button" tabindex="0" class="wrap-today" ng-click="ctrl.toggleWeek($event);ctrl.storeSelezionatoSmall(store,'orari_map')" ng-keydown="$event.keyCode === 13 && ctrl.toggleWeek()">
							<svg class="iconHours" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
								<circle cx="8" cy="8" r="6.67" stroke="#2B3F6C"></circle>
								<path d="M8 5.33V7.82c0 .11.056.215.148.277L10 9.33" stroke="#2B3F6C" stroke-linecap="round"></path>
							</svg>
							<span>
								<strong>${storeStatus.status}</strong>
								${storeStatus.status === this.storeLocatorSettings.localizedStrings.LBL_APERTO ? ` · ${this.storeLocatorSettings.localizedStrings.LBL_CHIUDEA} ${storeStatus.closesAt}` : (storeStatus.status === this.storeLocatorSettings.localizedStrings.LBL_CHIUSO ? ` · ${this.storeLocatorSettings.localizedStrings.LBL_APREA} ${storeStatus.nextOpen}` : '')}
							</span>
							<svg class="iconArrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
								<rect width="20" height="20" fill="#F0F3F7" />
								<path d="M6 8L10 12L14 8" stroke="#232120" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round" />
							</svg>
						</div>
						<ul class="week" ng-class="{ 'active': ctrl.isWeekActive }">
						${store.hours.map(dayEntry => {
			const isCurrentDay = (currentDay.toLowerCase().startsWith(dayEntry.day.toLowerCase()) ? 'current-day' : '');

			const orari = dayEntry.orari.includes(this.storeLocatorSettings.localizedStrings.LBL_CHIUSO) ? this.storeLocatorSettings.localizedStrings.LBL_CHIUSO : dayEntry.orari.join(' / ');
			return `<li class="${isCurrentDay}"><div class="wrap-hours"><div class="item">${dayEntry.day}:</div> <div class="item item-orario">${orari}</div></div></li>`;
		}).join('')}
					</ul>
					</div>
				</div>
				` : ''}
				<div class="storePhone">
					<div class="phoneTitle">Telefono</div>
					<div class="phoneNumber">
						<svg class="iconPhone" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M11.708 12.48c-1.303 1.303-4.64.078-7.453-2.735C1.442 6.93.218 3.595 1.52 2.292L2.38 1.434c.593-.592 1.568-.577 2.18.034l1.33 1.329c.611.611.626 1.587.034 2.18L5.738 5.162c-.32.32-.352.836-.054 1.196.287.348.596.694.931 1.029.335.335.681.644 1.028.93.36.298.875.265 1.195-.055l.185-.184c.592-.593 1.568-.577 2.18.034l1.33 1.329c.612.612.628 1.587.034 2.18l-.858.858z" stroke="#2B3F6C"></path>
						</svg>
						<a  href="tel:${store.phone}" ng-click="ctrl.storeSelezionatoSmall(store,'tel_map')"
							class="dtEventSend"
							data-gtm-eventname="store_locator_interactions"
                            data-gtm-position="mappa"
                            data-gtm-label="get_call"
                            data-gtm-nomecontenuto="${store.nomeContenuto}"
						>${store.phone}</a>
					</div>
				</div>
			</div>
			<div class="infoFooter">
				<a  class="btn btn--outline dtEventSend" data-gtm-eventname="store_locator_interactions" data-gtm-position="mappa"
				data-gtm-label="get_direction" data-gtm-nomecontenuto="${store.nomeContenuto}" href="${directionsUrl}" target="_blank"
				onclick="storeSelezionato(${store.id},'${store.name4GA}','${store.indirizzo4GA}','${store.type}','${store.citta4GA}','${store.agenteRif}','indica')">Ottieni indicazioni</a>
			</div>
		</div>
		`;


		const compiledContent = this.$compile(content)(Object.assign(this.$scope, { store }));
		this.infoWindow.setContent(compiledContent[0]);
		this.$scope.$applyAsync();
		this.infoWindow.open(this.map, marker);

		this.$timeout(() => {
			this.activeStore = store;
			this.updateMarkerIcons(store);
		});
	}

	toggleWeek() {
		this.isWeekActive = !this.isWeekActive;
	}

	resetForm() {
		this.model = {}; // Resetta il modello
		this.formSubmitted = false; // Assicurati che formSubmitted sia false
		if (this.$scope.ctrlForm) {
			this.$scope.ctrlForm.$setPristine(); // Resetta lo stato del form a pristine
			this.$scope.ctrlForm.$setUntouched(); // Resetta lo stato del form a untoched
		}
		this.fancyStore = null; // Resetta fancyStore
		this.fancyAgent = null; // Resetta fancyAgent
		this.state.ready(); // Assicurati che lo stato sia pronto per una nuova operazione
	}

	onSubmit() {
		var inputCaptcha = document.querySelector('.g-recaptcha-response');
		if (inputCaptcha) {
			this.model.Captcha = inputCaptcha.value;
		} else {
			this.model.Captcha = '';
		}

		// Se il CAPTCHA non è valido, mostra un messaggio di errore persistente
		if (!this.model.Captcha) {
			this.showCaptchaError = true;  // Variabile per controllare la visualizzazione del messaggio di errore
			this.$timeout(() => {
				const errorMessageElement = document.getElementById('captcha-error-message');
				if (errorMessageElement) {
					errorMessageElement.style.display = 'block';  // Mostra il messaggio di errore
				}
			}, 0);
			return;  // Esci dalla funzione per evitare ulteriori processi finché CAPTCHA non è completato
		} else {
			this.showCaptchaError = false;  // Nasconde il messaggio di errore quando CAPTCHA è valido
		}

		// Procedura di invio standard se il CAPTCHA è valido
		if (this.fancyStore) {
			this.model.storeID = this.fancyStore.id;
		}

		// console.log('ContactsCtrl.onSubmit', this.model);

		if (this.state.busy()) {
			this.$http.post('/WS/wsUsers.asmx/ContactStore', { data: this.model }).then(
				success => {
					if (success.data.d.Status) {

						this.state.success();
						GtmService.push({ "event": "Action Complete" });
						this.formSubmitted = true;
						//this.resetFormAndHideMessage();

						const obj = Object.assign({}, window.objDataLayerInfo);
						obj["eventname"] = "store_locator_request_sent";
						obj["nomecontenuto"] = success.data.d.Props.StoreName;
						GtmService.push(obj);

					} else {
						this.state.error();
					}
				},
				error => {
					this.error = error;
				}
			);

			this.$timeout(() => {
				this.state.ready();
			}, 2000);
		}
	}

	onSubmitAgent() {
		var inputCaptcha = document.querySelector('.g-recaptcha-response');
		if (inputCaptcha) {
			this.model.Captcha = inputCaptcha.value;
		} else {
			this.model.Captcha = '';
		}

		if (this.fancyAgent) {
			this.model.agentID = this.fancyAgent.id;
		}

		// console.log('ContactsCtrl.onSubmit', this.model);

		if (this.state.busy()) {
			this.$http.post('/WS/wsUsers.asmx/ContactAgente', { data: this.model }).then(
				success => {
					if (success.data.d.Status) {
						this.state.success();
						GtmService.push({ "event": "Action Complete" });
						this.formSubmitted = true;

						var prov = "";
						if (window.data.provinciaGA4 && !window.data.searchByTextBox)
							prov = "_" + window.data.provinciaGA4;
						else
							prov = "_-";

						const obj = Object.assign({}, window.objDataLayerInfo);
						obj["eventname"] = "store_locator_request_sent";
						obj["nomecontenuto"] = success.data.d.Props.AgentName + prov;
						GtmService.push(obj);


					}
					else {
						this.state.error();
					}
				},
				error => {
					this.error = error;
				}
			);

			this.$timeout(() => {
				this.state.ready();
			}, 2000);
		}
	}

	onInvalid() {
		this.$scope.$broadcast('onInvalid');
	}

	toggleWeekActive(event, storeId) {
		if (event && event.stopPropagation) event.stopPropagation();

		if (storeId) {
			this.weekActiveList[storeId] = !this.weekActiveList[storeId];
		} else {
			this.weekActive = !this.weekActive;
		}
	}

	handleTabletTouch(event, toggleId) {
		// Funzione per rilevare se siamo su un tablet grande (>= 768px e touch device)
		const isLargeTablet = () => {
			return this.$window.innerWidth >= 768 &&
				('ontouchstart' in this.$window || this.$window.navigator.maxTouchPoints > 0);
		};

		// Solo su tablet grandi
		if (!isLargeTablet()) {
			return;
		}

		// Previeni eventi duplicati
		if (event) {
			event.preventDefault();
			event.stopPropagation();
		}

		// Gestisci il toggle
		if (toggleId === 'fancy-store') {
			this.weekActive = !this.weekActive;
		} else if (toggleId && toggleId.startsWith('store-')) {
			const storeId = toggleId.replace('store-', '');
			if (!this.weekActiveList) {
				this.weekActiveList = {};
			}
			this.weekActiveList[storeId] = !this.weekActiveList[storeId];
		}

		// Forza l'aggiornamento del DOM
		try {
			this.$scope.$apply();
		} catch (e) {
			// $scope.$apply() già in corso
		}
	}

	setupTabletTouchHandlers() {
		// Aspetta un po' per assicurarsi che il DOM sia completamente renderizzato
		this.$timeout(() => {
			// Handler per fancy-store
			const fancyStoreElement = document.getElementById('fancy-store-toggle');

			if (fancyStoreElement) {
				// Rimuovi vecchi listeners se esistono per evitare duplicati
				const oldTouchStart = fancyStoreElement._touchStartHandler;
				const oldTouchEnd = fancyStoreElement._touchEndHandler;
				const oldClick = fancyStoreElement._clickHandler;

				if (oldTouchStart) fancyStoreElement.removeEventListener('touchstart', oldTouchStart);
				if (oldTouchEnd) fancyStoreElement.removeEventListener('touchend', oldTouchEnd);
				if (oldClick) fancyStoreElement.removeEventListener('click', oldClick);

				// Crea nuovi handlers e salvali come proprietà dell'elemento
				const touchStartHandler = (e) => this.handleTouchStart(e, 'fancy-store');
				const touchEndHandler = (e) => this.handleTouchEnd(e, 'fancy-store');
				const clickHandler = (e) => this.handleClick(e, 'fancy-store');

				fancyStoreElement._touchStartHandler = touchStartHandler;
				fancyStoreElement._touchEndHandler = touchEndHandler;
				fancyStoreElement._clickHandler = clickHandler;

				// Aggiungi nuovi listeners
				fancyStoreElement.addEventListener('touchstart', touchStartHandler, { passive: false });
				fancyStoreElement.addEventListener('touchend', touchEndHandler, { passive: false });
				fancyStoreElement.addEventListener('click', clickHandler, { passive: false });
			}

			// Handler per store individuali (questi potrebbero già esistere)
			const storeToggles = document.querySelectorAll('[data-tablet-toggle^="store-"]');

			storeToggles.forEach(element => {
				const toggleId = element.getAttribute('data-tablet-toggle');

				// Rimuovi vecchi listeners
				const oldTouchStart = element._touchStartHandler;
				const oldTouchEnd = element._touchEndHandler;
				const oldClick = element._clickHandler;

				if (oldTouchStart) element.removeEventListener('touchstart', oldTouchStart);
				if (oldTouchEnd) element.removeEventListener('touchend', oldTouchEnd);
				if (oldClick) element.removeEventListener('click', oldClick);

				// Crea nuovi handlers
				const touchStartHandler = (e) => this.handleTouchStart(e, toggleId);
				const touchEndHandler = (e) => this.handleTouchEnd(e, toggleId);
				const clickHandler = (e) => this.handleClick(e, toggleId);

				element._touchStartHandler = touchStartHandler;
				element._touchEndHandler = touchEndHandler;
				element._clickHandler = clickHandler;

				element.addEventListener('touchstart', touchStartHandler, { passive: false });
				element.addEventListener('touchend', touchEndHandler, { passive: false });
				element.addEventListener('click', clickHandler, { passive: false });
			});
		}, 500);
	}

	handleTouchStart(event, toggleId) {
		this.touchStarted = true;
		this.lastTouchId = toggleId;
	}

	handleTouchEnd(event, toggleId) {
		if (!this.touchStarted || this.lastTouchId !== toggleId) {
			return;
		}

		this.touchStarted = false;

		const isLargeTablet = this.$window.innerWidth >= 768 &&
			('ontouchstart' in this.$window || this.$window.navigator.maxTouchPoints > 0);

		if (isLargeTablet) {
			event.preventDefault();
			event.stopPropagation();

			this.performToggle(toggleId);
		}
	}

	handleClick(event, toggleId) {
		// Se abbiamo appena gestito un touch, non gestire anche il click
		if (this.touchStarted) {
			event.preventDefault();
			event.stopPropagation();
			return;
		}

		const isLargeTablet = this.$window.innerWidth >= 768 &&
			('ontouchstart' in this.$window || this.$window.navigator.maxTouchPoints > 0);

		if (!isLargeTablet) {
			// Desktop o tablet piccoli - usa il normale toggleWeekActive
			this.toggleWeekActive(event, toggleId === 'fancy-store' ? null : toggleId.replace('store-', ''));
		}
	}

	performToggle(toggleId) {
		if (toggleId === 'fancy-store') {
			this.weekActive = !this.weekActive;
		} else if (toggleId && toggleId.startsWith('store-')) {
			const storeId = toggleId.replace('store-', '');
			if (!this.weekActiveList) {
				this.weekActiveList = {};
			}
			this.weekActiveList[storeId] = !this.weekActiveList[storeId];
		}

		// Forza l'aggiornamento del DOM
		this.$scope.$apply();
	}

	getCurrentDay() {
		const language = this.getCurrentLocale().includes('fr') ? 'fr' : 'it';
		const today = new Date();
		const dayMapping = {
			"lunedì": "Lun",
			"martedì": "Mar",
			"mercoledì": "Merc",
			"giovedì": "Gio",
			"venerdì": "Ven",
			"sabato": "Sab",
			"domenica": "Dom"
		};
		const fullDay = today.toLocaleDateString(language === 'fr' ? 'fr-FR' : 'it-IT', { weekday: 'long' }).toLowerCase();
		return dayMapping[fullDay] || fullDay;
	}
	getIsCurrentDay(day) {
		return this.getCurrentDay.startsWith(day);
	}

	isStoreOpen(store) {
		const closedStatus = this.storeLocatorSettings.localizedStrings.LBL_CHIUSO;
		const openStatus = this.storeLocatorSettings.localizedStrings.LBL_APERTO;

		if (!store || !store.hours) {
			return { status: closedStatus, closesAt: null, nextOpen: null };
		}

		const today = new Date();
		const day = this.getCurrentDay();
		const hoursEntry = store.hours.find(entry => day.toLowerCase().startsWith(entry.day.toLowerCase())); //(entry => entry.day === day);

		if (!hoursEntry || hoursEntry.orari.includes(closedStatus)) {
			return { status: closedStatus, closesAt: null, nextOpen: this.findNextOpenTodayOrFuture(store.hours, day) };
		}

		const currentTime = today.getHours() * 60 + today.getMinutes();
		const times = hoursEntry.orari.map(range => {
			const [open, close] = range.trim().split('–').map(time => {
				const [hours, minutes] = time.split(':').map(Number);
				return hours * 60 + minutes;
			});
			return { open, close };
		});

		for (const { open, close } of times) {
			if (currentTime >= open && currentTime <= close) {
				return { status: openStatus, closesAt: this.minutesToTime(close), nextOpen: null };
			}
		}

		// Se è chiuso, trova il prossimo orario di apertura
		return { status: closedStatus, closesAt: null, nextOpen: this.findNextOpenTodayOrFuture(store.hours, day, currentTime) };
	}

	findNextOpenTodayOrFuture(hours, currentDay, currentTime = 0) {
		const daysOfWeek = ["Lun", "Mar", "Merc", "Gio", "Ven", "Sab", "Dom"];
		let startIndex = daysOfWeek.indexOf(currentDay);

		// Controlla prima per eventuali orari di apertura più tardi oggi
		var todayEntry = hours.find(entry => currentDay.toLowerCase().startsWith(entry.day.toLowerCase()));
		if (todayEntry) {
			const nextOpeningToday = todayEntry.orari.find(range => {
				const [open] = range.split('–').map(time => {
					const [hours, minutes] = time.split(':').map(Number);
					return hours * 60 + minutes;
				});
				return open > currentTime;
			});
			if (nextOpeningToday) {
				return ` ${nextOpeningToday.split('–')[0]}`;
			}
		}

		// Se non ci sono più orari oggi, cerca nel giorno successivo
		for (let i = 1; i < 7; i++) {
			const dayIndex = (startIndex + i) % 7;
			const nextDay = daysOfWeek[dayIndex];
			const nextEntry = hours.find(entry => entry.day === nextDay && !entry.orari.includes(this.storeLocatorSettings.localizedStrings.LBL_CHIUSO));

			if (nextEntry) {
				const openTime = nextEntry.orari[0].split('–')[0];
				return `${nextDay}  ${openTime}`;
			}
		}
		return null;
	}

	minutesToTime(minutes) {
		const hours = Math.floor(minutes / 60);
		const mins = minutes % 60;
		return `${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}`;
	}


	loadAgentData(tipo, countrycode, province, city, areac, shortn, storeTrovati) {

		var stringaChiamata = `/api/store-locator/agenti-by-coords?tipo=${tipo}&countrycode=${countrycode}&provcode=${province}&citycode=${city}&areacode=${areac}&shortname=${shortn}`;
		this.$http.get(stringaChiamata)
			.then(response => {
				const agents = response.data;
				this.agents = agents;
				//console.log('Agents data fetched:', agents);

				// Assuming the API returns an array of agents, you can assign the first one
				this.agent = agents[0] || null;

				if (this.agent) {
					this.agent.nomeContenuto += "_agente_di_zona";

					if (window.data.provinciaGA4 && !window.data.searchByTextBox)
						this.agent.nomeContenuto += "_" + window.data.provinciaGA4;
					else
						this.agent.nomeContenuto += "_-";
				}

				// commento per forzare la compilazione
				if (!this.agent) {
					console.warn('No agent found for the provided location parameters.');
				}
				this.$scope.$applyAsync();
				if (window.ultimaRicerca != stringaChiamata) {
					scriviListaGA4(storeTrovati, agents);
					window.ultimaRicerca = stringaChiamata;
				}
				

			})
			.catch(error => {
				console.error('Error fetching agent data:', error);
			});
	}

	loadStores() {
		const countryRestriction = this.getCountryRestriction();
		this.$http.get('/api/store-locator/all').then(response => {
			// Filtra i negozi per includere solo quelli nel paese corretto
			this.stores = response.data.filter(store => store && store.country === countryRestriction.country.toUpperCase());
			this.initMap();
		}, error => {
			console.error('Failed to load store data:', error);
		});
	}

	loadGoogleMaps() {
		if (!window.storeLocatorSettings.apiKey && !IS_DEV) {
			throw (`Missing Google Map Api Key`);
		}

		// Controlla se l'API di Google Maps è già stata caricata
		if (typeof google !== 'undefined' && google.maps) {
			this.initMap();
			return;
		}
		const script = this.$document[0].createElement('script');
		script.src = `https://maps.googleapis.com/maps/api/js?key=` + window.storeLocatorSettings.apiKey + `&libraries=places&region=EN&language=en`;

		script.async = true;
		script.onload = () => this.initMap();
		this.$document[0].body.appendChild(script);
	}

	initMap() {
		if (!this.stores.length) {
			this.isLoadingMap = false;
			return;
		}

		this.infoWindow = new google.maps.InfoWindow();


		const countryRestriction = this.getCountryRestriction();

		this.$http.get('/client/docs/data/mapStyle.json').then(response => {
			const isMobile = window.innerWidth <= 768; // You can adjust the width as per your needs
			const zoomLevel = isMobile ? 5 : 6;
			const mapOptions = {
				zoom: zoomLevel,
				center: new google.maps.LatLng(countryRestriction.center.lat, countryRestriction.center.lng), // Center map based on locale
				mapTypeId: google.maps.MapTypeId.ROADMAP,
				styles: response.data // Apply custom map style
			};

			this.map = new google.maps.Map(document.getElementById('map'), mapOptions);

			const autocompleteOptions = this.getListCountryRestriction(); // { types: ['geocode'] };

			const autocompleteTop = new google.maps.places.Autocomplete(document.getElementById('searchBox'), autocompleteOptions);

			autocompleteTop.addListener('place_changed', () => {
				const place = autocompleteTop.getPlace();
				if (place.geometry) {
					const location = place.geometry.location;
					const formattedAddress = place.formatted_address;

					if (window.data.searchTraced == false) {
						var label = "-";
						var position = "search_bar";

						if (window.data.provinciaGA4) {
							label = window.data.provinciaGA4;

							if (!window.data.searchByTextBox)
								position = "listing_province";
						}

						var searchTerm = document.getElementById('searchBox').value;

						//alert("place_changed - 1");
						this.manageGA4StoreLocatorSearchEvent("store_locator_search", position, label, searchTerm);
						// Event "store_locator_search - fin"
					}

					this.performSearchWithLocation(location, formattedAddress);
				} else {
					console.error('Autocomplete returned place with no geometry');
				}
			});

			const autocompleteBottom = new google.maps.places.Autocomplete(document.getElementById('searchBoxBottom'), autocompleteOptions);

			autocompleteBottom.addListener('place_changed', () => {
				const place = autocompleteBottom.getPlace();
				if (place.geometry) {
					const location = place.geometry.location;

					// Event "store_locator_search - ini"
					var label = "-";
					var position = "search_bar";

					if (window.data.provinciaGA4) {
						label = window.data.provinciaGA4;

						if (!window.data.searchByTextBox)
							position = "listing_province";
					}

					var searchTerm = document.getElementById('searchBox').value;

					//alert("place_changed - 2");
					this.manageGA4StoreLocatorSearchEvent("store_locator_search", position, label, searchTerm);
					// Event "store_locator_search - fin"

					this.performSearchWithLocation(location, "");
				} else {
					console.error('Autocomplete returned place with no geometry');
				}
			});

			this.markers = this.stores.map((store) => {
				const marker = new google.maps.Marker({
					position: new google.maps.LatLng(store.lat, store.lng),
					title: store.name,
					icon: this.getMarkerIcon(store)
				});

				marker.store = store; // Associa lo store al marker

				marker.addListener('click', () => {


					this.map.setCenter(marker.getPosition());
					this.$timeout(() => {
						this.activeStore = store;
						this.updateMarkerIcons(store);
					});
					this.scrollToStore(store);
				});
				marker.setMap(this.map);
				return marker;
			});

			const renderer = {
				render({ count, position }) {
					const svg = window.btoa(`
						<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
						<rect width="48" height="48" rx="24" fill="#404040"/>
						</svg>
					`);

					return new google.maps.Marker({
						position,
						icon: {
							url: `data:image/svg+xml;base64,${svg}`,
							anchor: new google.maps.Point(24, 24),
						},
						label: {
							text: String(count),
							color: "white",
							fontSize: "14px",
							fontWeight: "bold",
						},
						zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
					});
				},
			};

			this.markerClusterer = new MarkerClusterer({
				map: this.map,
				markers: this.markers,
				renderer: renderer
			});


			this.isLoadingMap = false;
		}, error => {
			console.error('Failed to load map style:', error);
			this.isLoadingMap = false;
		});


		//var provList = $('ul.provList>li a');
		//$.each(provList, function (index, node) {
		//	$(this).on("click", function () {
		//		var provincia = $(this).data("title");

		//		const obj = Object.assign({}, window.objDataLayerInfo);
		//		obj["eventname"] = "store_locator_province";
		//		obj["label"] = provincia;
		//		GtmService.push(obj);
		//	});
		//})
	}

	getMarkerIcon(store) {
		if (store.type === 'Lea Ceramiche Ambassador') {
			return '/client/docs/img/pin/ambassador-pin.png';
		} else if (store.type === 'Partner Lea Ceramiche') {
			return '/client/docs/img/pin/rivenditore-pin.png';
		} else if (store.type === 'Fidelity' || store.type === '' || store.type === null) {
			return '/client/docs/img/pin/default-pin.png';
		} else if (store.type === 'Sede Centrale') {
			return '/client/docs/img/pin/default-pin.png';
		}
	}

	centerMapOnStore(store) {
		if (store) {
			const marker = this.markers.find(m => m.store.id === store.id);

			if (marker) {
				this.map.setCenter(marker.getPosition());
				this.openInfoWindow(marker, store);
			} else {
				console.warn("Marker not found for the selected store.");
			}
		}
	}


	updateMarkerIcons(selectedStore) {
		this.markers.forEach(marker => {
			const store = marker.store; // Access the store associated with the marker
			if (store) {
				marker.setIcon(store === selectedStore ? this.getSelectedMarkerIcon(store) : this.getMarkerIcon(store));
			}
		});
	}

	getSelectedMarkerIcon(store) {
		if (store.type === 'Lea Ceramiche Ambassador') {
			return '/client/docs/img/pin/ambassador-pin-selected.png';
		} else if (store.type === 'Partner Lea Ceramiche') {
			return '/client/docs/img/pin/rivenditore-pin-selected.png';
		} else if (store.type === 'Fidelity' || store.type === '' || store.type === null) {
			return '/client/docs/img/pin/default-pin-selected.png';
		} else if (store.type === 'Sede Centrale') {
			return '/client/docs/img/pin/default-pin-selected.png';
		}
	}

	calculateDistance(lat1, lng1, lat2, lng2) {
		const toRad = (value) => value * Math.PI / 180;
		const R = 6371; // Radius of the Earth in km
		const dLat = toRad(lat2 - lat1);
		const dLng = toRad(lng2 - lng1);
		const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
			Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
			Math.sin(dLng / 2) * Math.sin(dLng / 2);
		const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
		return R * c;
	}

	filterStoresByRadius(searchLocation, radius) {
		return this.stores.filter(store => {
			const distance = this.calculateDistance(
				searchLocation.lat(),
				searchLocation.lng(),
				store.lat,
				store.lng
			);
			store.distance = distance.toFixed(2); // Save the distance to the store object
			return distance <= radius;
		});
	}

	sortStoresByDistance(stores) {
		return stores.sort((a, b) => a.distance - b.distance);
	}

	sortStores(registerGa4Event) {
		if (this.searchLocationLat && this.searchLocationLng) {
			// Calculate distances for filteredStores
			this.filteredStores.forEach(store => {
				const distance = this.calculateDistance(
					this.searchLocationLat,
					this.searchLocationLng,
					store.lat,
					store.lng
				);
				store.distance = distance.toFixed(2);
			});
		}

		if (this.sortCriteria === 'distanza') {
			// Sort by distance
			this.filteredStores.sort((a, b) => a.distance - b.distance);

			if (registerGa4Event) {
				const obj = Object.assign({}, window.objDataLayerInfo);
				obj["eventname"] = "store_locator_order";
				obj["label"] = "distanza";
				GtmService.push(obj);
			}

		} else if (this.sortCriteria === 'rilevanza' || !this.sortCriteria) {

			if (registerGa4Event) {
				const obj = Object.assign({}, window.objDataLayerInfo);
				obj["eventname"] = "store_locator_order";
				obj["label"] = "rilevanza";
				GtmService.push(obj);
			}

			// Sort by relevance and then by distance
			this.filteredStores.sort((a, b) => {
				if (a.type === 'Lea Ceramiche Ambassador' && b.type !== 'Lea Ceramiche Ambassador') {
					return -1;
				}
				if (a.type !== 'Lea Ceramiche Ambassador' && b.type === 'Lea Ceramiche Ambassador') {
					return 1;
				}
				if (a.type === 'Partner Lea Ceramiche' && b.type !== 'Partner Lea Ceramiche') {
					return -1;
				}
				if (a.type !== 'Partner Lea Ceramiche' && b.type === 'Partner Lea Ceramiche') {
					return 1;
				}
				if (a.type === 'Fidelity' && b.type !== 'Fidelity') {
					return -1;
				}
				if (a.type !== 'Fidelity' && b.type === 'Fidelity') {
					return 1;
				}
				// If they are of the same type, sort by distance
				return a.distance - b.distance;
			});
		}

		this.$scope.$applyAsync();
	}

	scrollToStore(store) {
		this.$timeout(() => {
			const storeElement = this.$document[0].querySelector(`li[data-store-id='${store.id}']`);
			if (storeElement) {
				storeElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
			}
		}, 0);
	}

	handleEnterKey(event) {
		document.getElementById('map-overlay').classList.remove('active'); // Rimuove l'overlay

		window.data.searchByTextBox = true;
		window.data.searchTraced = false;

		if (event.key === 'Enter') {
			var label = "-";

			if (window.data.provinciaGA4)
				label = window.data.provinciaGA4;

			var searchTerm = document.getElementById('searchBox').value;

			// determina la posizione per il tracciamento
			var position = "search_bar";

			//alert("place_changed - 1");
			this.manageGA4StoreLocatorSearchEvent("store_locator_search", position, label, searchTerm);
			// Event "store_locator_search - fin"

			window.data.searchTraced = true;

			this.handleSearchButtonClick();  // Chiama la funzione di ricerca con il bottone
		}
	}

	performSearch(traceGA4) {
		document.getElementById('map-overlay').classList.remove('active'); // Rimuove l'overlay
		const input = document.getElementById('searchBox').value; //this.searchQuery;
		// console.log('Performing search for:', input); // Log per il debug
		const geocoder = new google.maps.Geocoder();

		const isZipCode = /^\d{4,6}$/.test(input);
		let geocodeRequest = { 'address': input };

		if (isZipCode) {
			// Restrizione della ricerca ai soli CAP italiani
			geocodeRequest.componentRestrictions = { country: 'IT' };
		}

		geocoder.geocode(this.addressForGeocoder(geocodeRequest), (results, status) => {
			if (status === google.maps.GeocoderStatus.OK) {
				// console.log('Geocode results:', results); // Log per il debug
				const location = results[0].geometry.location;

				var country = results[0].address_components.find(component => component.types.includes("country"))?.short_name || '';
				country = country.toUpperCase();
				if (!this.listCountryCode.find(c => c.toUpperCase() == country)) {
					document.getElementById('searchBox').value = "";
					return;
				}

				if (traceGA4) {
					// Event "store_locator_search - ini"
					var label = "-";
					var position = "search_bar";

					if (window.data.provinciaGA4) {
						label = window.data.provinciaGA4;

						if (!window.data.searchByTextBox)
							position = "listing_province";
					}

					var searchTerm = document.getElementById('searchBox').value;

					//alert("performSearch");
					this.manageGA4StoreLocatorSearchEvent("store_locator_search", position, label, searchTerm);
					// Event "store_locator_search - fin"
				}
				this.performSearchWithLocation(location, "");
			} else {
				console.error('Geocoder failed due to: ' + status);
			}
		});
	}

	performSearchWithLocation(location, formattedAddress) {

		document.getElementById('map-overlay').classList.remove('active'); // Rimuove l'overlay
		this.searchLocation = location;

		// Gestisce entrambi i casi in cui 'location.lat' è una funzione o una proprietà
		this.searchLocationLat = typeof location.lat === 'function' ? location.lat() : location.lat;
		this.searchLocationLng = typeof location.lng === 'function' ? location.lng() : location.lng;
		// console.log('Search Location Set:', this.searchLocationLat, this.searchLocationLng); // Debug log

		const geocoder = new google.maps.Geocoder();

		let address = document.querySelector('.search-input').value;

		// Se l'indirizzo è vuoto, utilizza 'formattedAddress' o effettua il reverse geocoding
		if (!address) {
			if (formattedAddress) {
				address = formattedAddress;
				// Aggiorna il campo di input della ricerca
				document.querySelector('.search-input').value = address;
			} else {
				// Effettua il reverse geocoding per ottenere l'indirizzo
				geocoder.geocode({ location: { lat: this.searchLocationLat, lng: this.searchLocationLng } }, (results, status) => {
					if (status === google.maps.GeocoderStatus.OK && results[0]) {
						address = results[0].formatted_address;
						this.searchQuery = address;
						document.querySelector('.search-input').value = address;
						// Procedi con il resto della funzione utilizzando l'indirizzo ottenuto
						this.processGeocodingResults(results[0], { lat: this.searchLocationLat, lng: this.searchLocationLng });



					} else {
						console.error('Geocoder failed due to:', status);
					}

				});
				return; // Esci dalla funzione qui; il resto verrà eseguito nel callback
			}
		}



		// Procede se l'indirizzo è disponibile
		geocoder.geocode({ address: this.addressForGeocoder(address) }, (results, status) => {
			if (status === google.maps.GeocoderStatus.OK && results[0]) {
				this.processGeocodingResults(results[0], { lat: this.searchLocationLat, lng: this.searchLocationLng });
			} else {
				console.error('Geocoder failed due to:', status);
			}
		});
	}

	processGeocodingResults(result, location) {
		const ordinatiS = {
			"country": 1,
			"administrative_area_level_1": 2,
			"administrative_area_level_2": 3,
			"administrative_area_level_3": 4,
			"administrative_area_level_4": 5,
			"administrative_area_level_5": 6,
			"locality": 7,
			"route": 8,
			"postal_code": 9,
			"street_address": 10
		};
		const addressComponents = result.address_components;

		// Estrai i componenti dell'indirizzo
		const country = addressComponents.find(component => component.types.includes("country"))?.short_name || '';
		const province = addressComponents.find(component => component.types.includes("administrative_area_level_2"))?.short_name || '';
		const city = addressComponents.find(component => component.types.includes("administrative_area_level_3"))?.short_name || '';
		const areac = addressComponents.find(component => component.types.includes("administrative_area_level_1"))?.short_name || '';

		let tipo = '';
		let shortn = '';
		for (let i = addressComponents.length - 1; i >= 0; i--) {
			const componente = addressComponents[i];
			for (let j = 0; j < componente.types.length; j++) {
				if (this.ordinatiS[componente.types[j]]) {
					tipo = componente.types[j];
					shortn = componente.short_name;
					break;
				}
			}
			//	if (tipo) break;
		}

		// console.log('tipo:', tipo, '- shortn:', shortn, '- country:', country, '- province:', province, '- city:', city, '- areac:', areac);

		// Effettua la chiamata API al nuovo endpoint con i parametri corretti
		this.$http.get(`/api/store-locator/by-coords?lat=${this.searchLocationLat}&lng=${this.searchLocationLng}&tipo=${tipo}&countrycode=${country}&provcode=${province}&citycode=${city}&areacode=${areac}&shortname=${shortn}`)
			.then(response => {
				const filteredStores = response.data;
				// console.log('Filtered Stores:', filteredStores);

				if (filteredStores.length === 0) {
					console.warn('No stores found within the specified radius.');
					const noStoreElement = document.querySelector('.no-store');
					const storeFiltersElement = document.querySelector('.storeFilters');
					if (noStoreElement) {
						noStoreElement.style.display = 'block';
					}
					if (storeFiltersElement) {
						storeFiltersElement.style.display = 'none';
					}
				} else {
					const noStoreElement = document.querySelector('.no-store');
					const storeFiltersElement = document.querySelector('.storeFilters');
					if (noStoreElement) {
						noStoreElement.style.display = 'none';
					}
					if (storeFiltersElement) {
						storeFiltersElement.style.display = 'block';
					}
				}

				this.filteredStores = filteredStores;
				this.sortStores();
				this.updateMapMarkers();

				const bounds = new google.maps.LatLngBounds();
				this.filteredStores.forEach(store => {
					const storeLocation = new google.maps.LatLng(store.lat, store.lng);
					bounds.extend(storeLocation);
				});

				if (this.filteredStores.length > 0) {
					if (this.map) {
						this.map.fitBounds(bounds);
					}
				} else {
					this.map.setCenter(location);
					this.map.setZoom(14);
				}

				// Carica i dati dell'agente in base alla nuova posizione
				this.loadAgentData(tipo, country, province, city, areac, shortn, filteredStores);
				
				


				this.$timeout(() => {
					this.showResults = true;
					this.scrollToMapSection();
				});
			})
			.catch(error => {
				console.error('Failed to fetch filtered stores:', error);
			});
	}

	scrollToMapSection() {
		this.$timeout(() => {
			const mapSection = this.$document[0].querySelector('.section--map');
			if (mapSection) {
				this.$window.scrollTo({
					top: mapSection.offsetTop,
					behavior: 'smooth'
				});
			}
		}, 0);
	}

	generateHoursHtml(store) {
		const openLabel = this.storeLocatorSettings.localizedStrings.LBL_APERTO;
		const closedLabel = this.storeLocatorSettings.localizedStrings.LBL_CHIUSO;

		// Mappa ogni giorno della settimana con gli orari
		return store.hours.map(dayEntry => {
			const day = dayEntry.day;
			const orari = dayEntry.orari.includes(closedLabel) ? closedLabel : dayEntry.orari.join(' / ');
			return `<li>${day}: ${orari}</li>`;
		}).join('');
	}

	updateMapMarkers() {
		if (this.markerClusterer) {
			this.markerClusterer.clearMarkers();
		}

		// Remove existing markers from the map
		if (this.markers) {
			this.markers.forEach(marker => marker.setMap(null));
		}

		// Create new markers for filteredStores
		this.markers = this.filteredStores.map(store => {
			const marker = new google.maps.Marker({
				position: new google.maps.LatLng(store.lat, store.lng),
				title: store.name,
				icon: this.getMarkerIcon(store),
				map: this.map
			});

			marker.store = store;

			marker.addListener('click', () => {
				this.openInfoWindow(marker, store);

				// Existing code for event tracking and UI updates
				const obj = Object.assign({}, window.objDataLayerInfo);
				let nomeSt = store.name;
				if (!nomeSt) { nomeSt = "-" }
				else {
					nomeSt = nomeSt.replaceAll(" ", "_").toLowerCase() + "_";
					nomeSt = nomeSt.replaceAll("_-_", "_");
				}
				if (window.data.provinciaGA4 && !window.data.searchByTextBox) {
					nomeSt = nomeSt + window.data.provinciaGA4;
				} else {
					nomeSt += "-";
				}
				obj["eventname"] = "store_locator_interactions";
				obj["position"] = "mappa";
				obj["label"] = "seleziona_store";
				obj["nomecontenuto"] = nomeSt;
				GtmService.push(obj);

				storeSelezionato2(store, 'click_map');

				this.map.setCenter(marker.getPosition());
				this.$timeout(() => {
					this.activeStore = store;
					this.showBtnTop = true;
					this.updateMarkerIcons(store);
				});
				this.scrollToStore(store);
			});

			return marker;
		});

		// Use MarkerClusterer to cluster the new markers
		this.markerClusterer = new MarkerClusterer({
			map: this.map,
			markers: this.markers,
			renderer: {
				render({ count, position }) {
					const svg = window.btoa(`
						<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
						<rect width="48" height="48" rx="24" fill="#404040"/>
						</svg>
					`);

					return new google.maps.Marker({
						position,
						icon: {
							url: `data:image/svg+xml;base64,${svg}`,
							anchor: new google.maps.Point(24, 24),
						},
						label: {
							text: String(count),
							color: "white",
							fontSize: "14px",
							fontWeight: "bold",
						},
						zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
					});
				},
			}
		});
	}

	useMyPosition() {
		document.getElementById('map-overlay').classList.remove('active');
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(position => {
				const latLng = { lat: position.coords.latitude, lng: position.coords.longitude };

				const geocoder = new google.maps.Geocoder();
				geocoder.geocode({ location: latLng }, (results, status) => {
					if (status === google.maps.GeocoderStatus.OK && results[0]) {
						const address = results[0].formatted_address;
						this.searchQuery = address;
						document.querySelector('.search-input').value = address; // Update input field

						// Event "store_locator_find_position - ini"
						var label = "-";
						if (window.data.provinciaGA4)
							label = window.data.provinciaGA4;


						var searchTerm = "";
						if (address !== undefined && address != "")
							searchTerm = address; // Voce scelta nella lista
						else
							searchTerm = document.getElementById('searchBox').value;

						this.manageGA4StoreLocatorSearchEvent("store_locator_find_position", "search_bar", label, searchTerm);
						// Event "store_locator_find_position - fin"

						this.performSearchWithLocation(latLng, address);
					} else {
						console.error('Geocoder failed due to:', status);
					}
				});
			}, error => {
				console.error('Geolocation error:', error);

				alert('Unable to retrieve your location.');
			});
		} else {
			alert('Geolocation is not supported by this browser.');
		}
	}

	setFancyStoreData(store) {
		this.fancyStore = store;
		this.$timeout(() => {
			$('body').css('overflow', 'hidden');
			$('html').css('overflow', 'hidden');
			$.fancybox.open({
				src: '#fancy-store',
				type: 'inline',
				opts: {
					afterShow: () => {
						// Configura i touch handlers dopo che il fancy store è visibile
						this.setupTabletTouchHandlers();
						if (typeof window.captchaOK === 'function') {
							window.captchaOK();
						}
						this.$scope.$applyAsync();
					},
					afterClose: () => {
						$('body').css('overflow', 'auto');
						$('html').css('overflow', 'auto');
						this.resetForm();
					}
				}
			});
		}, 0);
	}

	setFancyAgentData(agent) {
		this.fancyAgent = agent;
		this.$timeout(() => {
			$('body').css('overflow', 'hidden');
			$('html').css('overflow', 'hidden');
			$.fancybox.open({
				src: '#fancy-agent',
				type: 'inline',
				opts: {
					afterShow: () => {
						this.$scope.$applyAsync();
					},
					afterClose: () => {
						$('body').css('overflow', 'auto');
						$('html').css('overflow', 'auto');
						this.resetForm();
					}
				}
			});
		}, 0);
	}

	toggleMap() {
		this.showMap = !this.showMap;
	}

	scrollToMap() {
		this.$timeout(() => {
			const mapElement = this.$document[0].querySelector('.section--map');
			if (mapElement) {
				this.$window.scrollTo({
					top: mapElement.offsetTop,
					behavior: 'smooth'
				});
				this.showBtnTop = false; // Hide the button after scrolling
			}
		}, 0);
	}

	resetFormAndHideMessage() {
		this.resetForm();  // Resetta il form
		this.formSubmitted = false;  // Nasconde il messaggio di successo
		$.fancybox.close();  // Chiude la fancybox
	}

	manageGA4StoreLocatorSearchEvent(eventName, position, label, searchTerm) {
		const obj = Object.assign({}, window.objDataLayerInfo);

		obj["eventname"] = eventName;

		if (position != "")
			obj["position"] = position;

		obj["label"] = label;
		obj["searchterm"] = searchTerm;

		GtmService.push(obj);
	}

	getProvinceGA4() {
		return window.data.provinciaGA4 && !window.data.searchByTextBox ? window.data.provinciaGA4 : "-";
	}

	getStoreNameWithProvinceManage(storeName) {
		return window.data.provinciaGA4 ? storeName : storeName += "_-";
	}

	storeSelezionatoSmall(store, azione) {
		storeSelezionato2(store, azione);
	}
}

MapCtrl.$inject = ['$scope', '$location', '$timeout', '$document', '$window', '$http', 'StateService', '$compile'];

export default MapCtrl;
